"use strict";

class MortgageCalculatorController {
    
    constructor(SSAppService) {
        const self = this;

        self.SSAppService = SSAppService;

        self.loan = 0;
        self.price = 0;
        self.loanAmount = "";
        self.downPayment = 0;
        self.tenure = 0;
        self.interestRate = 0;
        self.years = 0;
        self.monthly_payment = 0;

        self.init();

    }

    init() {
        const self = this;
    }

    convertToNumber(str) {
        if(str)
            return str.toString().replace(/,/g, "");
        return str;
    }

    convertToPrice(num) {
        // console.log('num',num);
        return (num ==0 || num === undefined) ? "" : num.toLocaleString("en-US");
    }
    
    calculateLoan() {
        const self = this;
        self.loan = self.convertToNumber(self.price) - self.convertToNumber(self.downPayment);
        self.loanAmount = self.convertToPrice(self.loan);
        return self.loanAmount;
    }

    calculatePayment(countryCode) {
        
        const self = this;
        self.loan = self.convertToNumber(self.loanAmount);
        // self.calculateLoan();

        let interest = self.interestRate / 100;

        let c = interest / 12;
        let n = self.tenure * 12;

        let calculation = Math.round(self.loan * c * Math.pow(1 + c, n) / (Math.pow(1 + c, n) - 1)); 
        if (calculation !== calculation) {
            calculation = 0;
        }
      
        // if (self.price !==0 || self.downPayment !== 0) {
        if (self.loan !== 0 && c !== 0 && n !== 0) {
            self.monthly_payment = self.SSAppService.getCurrencySymbol(countryCode) + self.convertToPrice(calculation) + " / mo";
    
            let principal = calculation - (self.loan * c);

            self.starting_principal = self.SSAppService.getCurrencySymbol(countryCode) + self.convertToPrice(Math.round(principal));
            // console.log('starting_principal', calculation, Math.round(principal), self.convertToPrice(Math.round(principal)))

            self.starting_interest = self.SSAppService.getCurrencySymbol(countryCode) + self.convertToPrice(Math.round(calculation - principal));

            let total_payment = calculation * n;
            let total_interest = total_payment - self.loan;
            self.total_interest = self.SSAppService.getCurrencySymbol(countryCode) + self.convertToPrice(total_interest);
            self.total_payment = self.SSAppService.getCurrencySymbol(countryCode) + self.convertToPrice(total_payment);
        
            return self.monthly_payment; 
        //Math.round(num * 100) / 100 
        }
        
    }

}

MortgageCalculatorController.$inject = ['SSAppService'];
app.controller('MortgageCalculatorController', MortgageCalculatorController);
